/**
 * Maps bundle name → list of compatible session event-type names.
 * Used to ensure sessions are only auto-assigned to type-compatible bundles.
 * Sourced from apps/server/src/migration/data/mapping/bundle-event-types.ts
 */
export const mapOfBundleWithEvents: Record<string, string[]> = {
  'Cancer Care: 45 minutes': ['1:1 Cancer Care Therapy session'],
  'Therapy session: 45 minutes (cancer care)': [
    '1:1 Cancer Care Therapy session',
  ],
  'Therapy: Reschedule Fee': [
    '1:1 Cancer Care Therapy session',
    '1:1 Clinical Therapy session (45 minutes)',
    '1:1 Clinical Therapy session - For ADHD',
    '1:1 Clinical Therapy session - For ADHD - Child',
    'ADHD - Clinical Exploration',
    '1:1 Clinical Therapy session - For Personality Disorder',
    '1:1 Clinical Therapy session - Referral',
    '1:1 Sexual Health Therapy session (45 minutes)',
    '1:1 Sexual Health Therapy session (45 minutes) ',
    '1:1 Therapy session (45 minutes)',
    '1:1 Therapy session (45 minutes) ',
    '1:1 Therapy session (45 minutes) - Sexual Health',
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
    'Couples session: 45 minutes',
    'Couples session: 75 minutes ',
    'Couples session with Dr. Madhura (60 min)',
    'Individual Therapy Session',
  ],
  'Clinical therapy session: 45 minutes': [
    '1:1 Clinical Therapy session (45 minutes)',
    '1:1 Clinical Therapy session - Subscription',
  ],
  'Clinical therapy session: for ADHD': [
    '1:1 Clinical Therapy session - For ADHD',
    '1:1 Clinical Therapy session - For ADHD - Child',
  ],
  'ADHD Assessment': [
    '1:1 Clinical Therapy session - For ADHD',
    '1:1 Clinical Therapy session - For ADHD - Child',

  ],
  'Personality Disorder': [
    '1:1 Clinical Therapy session - For Personality Disorder',
  ],
  'Personality Disorder Assessment': [
    '1:1 Clinical Therapy session - For Personality Disorder',
  ],
  'Clinical Therapy Referral: 45 minutes': [
    '1:1 Clinical Therapy session - Referral',
  ],
  '4 Clinical therapy session: 45 minutes': [
    '1:1 Clinical Therapy session - Subscription',
  ],
  '8 Clinical therapy session: 45 minutes': [
    '1:1 Clinical Therapy session - Subscription',
  ],
  'Doctor consultation': [
    '1:1 Doctor Consultation',
    '1:1 Doctor Consultation - Rocket Health',
  ],
  'Dr. Madhura Samudra - 30 minutes': [
    '1:1 Psychiatry session with Dr. Madhura (30 min)',
  ],
  'Dr. Madhura Samudra - 45 minutes': [
    '1:1 Psychiatry session with Dr. Madhura (45 minutes)',
    'Dr. Madhura (45 min) - psychiatry subscription ',
  ],
  'Psychiatry: Reschedule Fee': [
    '1:1 Psychiatry session with Dr. Madhura (45 minutes)',
    'Online psychiatry evaluation',
    'Online psychiatry evaluation (referral)',
    'Online psychiatry evaluation - referral',
  ],
  'Sexual health therapy: 45 minutes': [
    '1:1 Sexual Health Therapy session (45 minutes)',
    '1:1 Sexual Health Therapy session (45 minutes) ',
    '1:1 Therapy session (45 minutes) - Sexual Health',
  ],
  "Men's performance": [
    '1:1 Sexual Health Therapy session (45 minutes)',
    '1:1 Sexual Health Therapy session (45 minutes) ',
    'Sexual Health consultation',
  ],
  'Therapy session: 45 minutes': [
    '1:1 Therapy session (45 minutes)',
    '1:1 Therapy session (45 minutes) ',
  ],
  'Get 25% off on your therapy sessions': [
    '1:1 Therapy session (45 minutes)',
    '1:1 Therapy session (45 minutes) ',
  ],
  'Get your first session at 25% off': [
    '1:1 Therapy session (45 minutes)',
    '1:1 Therapy session (45 minutes) ',
  ],
  'Therapy : Discounted Session': [
    '1:1 Therapy session (45 minutes)',
    '1:1 Therapy session (45 minutes) ',
  ],
  'Missed Session Discount': [
    '1:1 Therapy session (45 minutes)',
    '1:1 Therapy session (45 minutes) ',
  ],
  '1 Therapy session plan: 45 minutes': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  '4 Therapy session: 45 minutes each': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  '8 Therapy sessions: 45 minutes each': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  '16 Therapy sessions: 45 minutes each': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  'Gift - Single therapy session': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  'Gift - 4 Therapy session': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  'Gift - 8 Therapy session': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  '8 Therapy sessions: Limited time offer': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  '4 Therapy session: Offer': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  '16 Therapy sessions: Offer': [
    '1:1 Therapy session (45 minutes) - Subscription',
    '1:1 Therapy session (45 minutes) Subscription - Aavleen',
    '1:1 Therapy session (45 minutes) Subscription - Anjali',
    '1:1 Therapy session (45 minutes) Subscription - Jebin P',
    '1:1 Therapy session (45 minutes) Subscription- Jill M',
    '1:1 Therapy session (45 minutes) Subscription - Madhav',
    '1:1 Therapy session (45 minutes) Subscription - Shruthi',
    '1:1 Therapy session (45 minutes) Subscription - Shruti',
    '1:1 Therapy session (45 minutes) Subscription - Simran',
    '1:1 Therapy session (45 minutes) Subscription - Susan',
    '1:1 Therapy session (45 minutes) Subscription - Swaruti',
    '1:1 Therapy session (45 minute) Subscription - Prajakta',
  ],
  'Anxiety Support Group': [
    'Anxiety Support Group',
    'Rocket Health | Support Group',
  ],
  "Couple's Therapy": [
    'Couples session: 45 minutes',
    'Couples session: 75 minutes ',
    'Individual Therapy Session',
  ],
  "Couple's Therapy- Single Session": ['Couples session: 75 minutes '],
  "Couple's Therapy: 75 minutes": ['Couples session: 75 minutes '],
  "Couple's Therapy- 4 Sessions": ['Couples session: 75 minutes '],
  'Dr. Madhura: Couples Therapy': ['Couples session with Dr. Madhura (60 min)'],
  'Dr. Madhura - Couples Therapy (60 min)': [
    'Couples session with Dr. Madhura (60 min)',
  ],
  'Dr. Madhura Samudra: 1 x 30 minutes': [
    'Dr. Madhura (30 min) - psychiatry subscription',
  ],
  'Dr. Madhura: 4 x 30 minutes': [
    'Dr. Madhura (30 min) - psychiatry subscription',
  ],
  'Dr. Madhura - 4 sessions': [
    'Dr. Madhura (30 min) - psychiatry subscription',
  ],
  'Dr. Madhura - 20 mins/week subscription': [
    'Dr. Madhura (30 min) - psychiatry subscription',
  ],
  'Dr. Madhura: 4 x 45 minutes': [
    'Dr. Madhura (45 min) - psychiatry subscription ',
  ],
  'Dr. Madhura - 4 x 45 minutes': [
    'Dr. Madhura (45 min) - psychiatry subscription ',
  ],
  'Doctor consult + Therapy session': [
    'Free Follow - up | Doctor Consultation',
    'Sexual Health consultation ',
  ],
  'Gynaecology consultation | Rocket Health': ['Gynaecology Consultation'],
  'Women\u2019s Health panel': ['Gynaecology Consultation'],
  'Gynaecology consultation | Follow up': [
    'Gynaecology Consultation | Follow-up',
    'Gynaecology Consultation | Follow-up ',
    'Gynaecology Consultation | Follow-up  ',
  ],
  'Online psychiatry evaluation': ['Online psychiatry evaluation'],
  '1 Online psychiatry evaluation': [
    'Online psychiatry evaluation ',
    'Online psychiatry evaluation - follow up ',
    'Online psychiatry follow - up',
    'Online psychiatry - follow up - Dr. Manali Sharma',
    'Online psychiatry - follow up - Dr. Shikha Talati',
    'Online psychiatry - follow up - Dr. Supriya Davis',
  ],
  '4 Online psychiatry evaluation': [
    'Online psychiatry evaluation ',
    'Online psychiatry evaluation - follow up ',
    'Online psychiatry follow - up',
    'Online psychiatry - follow up - Dr. Manali Sharma',
    'Online psychiatry - follow up - Dr. Shikha Talati',
    'Online psychiatry - follow up - Dr. Supriya Davis',
  ],
  '1 Online psychiatry follow up': [
    'Online psychiatry evaluation - follow up ',
    'Online psychiatry follow - up',
    'Online psychiatry - follow up - Dr. Manali Sharma',
    'Online psychiatry - follow up - Dr. Shikha Talati',
    'Online psychiatry - follow up - Dr. Supriya Davis',
  ],
  '4 Online psychiatry follow ups': [
    'Online psychiatry evaluation - follow up ',
    'Online psychiatry follow - up',
    'Online psychiatry - follow up - Dr. Manali Sharma',
    'Online psychiatry - follow up - Dr. Shikha Talati',
    'Online psychiatry - follow up - Dr. Supriya Davis',
  ],
  'Online psychiatry evaluation - Follow up': [
    'Online psychiatry evaluation - follow up ',
    'Online psychiatry follow - up',
    'Online psychiatry - follow up - Dr. Manali Sharma',
    'Online psychiatry - follow up - Dr. Shikha Talati',
    'Online psychiatry - follow up - Dr. Supriya Davis',
  ],
  'Psychiatry evaluation': [
    'Online psychiatry evaluation (referral)',
    'Online psychiatry evaluation - referral',
  ],
  'Doctor consultation - follow up': ['Paid Follow - up | Doctor Consultation'],
  "Men\u2019s Health Panel": ['Sexual Health consultation'],
};

/**
 * Returns true only when the bundle name exists in the map and the session
 * name is listed as a compatible event type for that bundle.
 */
function normalizeMappingName(value: string): string {
  return value.trim();
}

function getCompatibleSessionsForBundle(
  bundleName: string
): string[] | undefined {
  const direct = mapOfBundleWithEvents[bundleName];
  if (direct) return direct;

  const normalized = normalizeMappingName(bundleName);
  const key = Object.keys(mapOfBundleWithEvents).find(
    (name) => normalizeMappingName(name) === normalized
  );
  return key ? mapOfBundleWithEvents[key] : undefined;
}

export function isSessionCompatibleWithBundle(
  sessionName: string,
  bundleName: string
): boolean {
  const compatible = getCompatibleSessionsForBundle(bundleName);
  if (!compatible) return false;

  const normalizedSession = normalizeMappingName(sessionName);
  return compatible.some(
    (allowed) => normalizeMappingName(allowed) === normalizedSession
  );
}
